<template>
  <div v-if="content" class="content">
    <Course
      v-if="content.ui_content_type === 'course'"
      :course="content"
      :isAuthenticated="isAuthenticated"
      :plansLink="plansLink"
      :learningAreaName="learningAreaName"
    />
    <ContentDelegate
      v-else
      v-bind="{
        content,
        contentType: content.ui_content_type,
        isAuthenticated,
        plansLink,
      }"
    />
  </div>
</template>

<script>
import Course from './content/Course.vue'
import ContentDelegate from './content/ContentDelegate.vue'

export default {
  name: 'Content',
  components: {
    Course,
    ContentDelegate,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 15px 10px 15px;
  margin: 20px 0;
  &:after {
    content: '';
    margin: 10px auto 0 auto;
    width: 100%;
    padding: 5px 0 0 0;
    border-bottom: 1px solid var(--gray);
  }
  @include tablet {
    padding: 20px 75px;
    margin: 0 0 0 35px;
    border-left: 1px dashed #707070;
    &:after {
      margin: 10px auto 0 50px;
    }
  }
}
</style>
